// Components
import DatePicker from "vue2-datepicker"

// Constants
import { STATUS_CODES, TRANSACTION_STATUS } from "@/app/constants/status-constants"

// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins"
import { dateMixins } from "@/app/mixins/utils/date-mixins"
import { shoppingMixins } from "@/app/mixins/components/shopping-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { userMixins } from "@/app/mixins/modules/user-mixins"
import { switchPetMixins } from "@/app/mixins/modules/switch-pet-mixins"

// Services
import TransactionService from "@/app/services/main/transaction/transaction-service"

export default {
	name: "ProductPurchaseListingContainer",
	components: {
		DatePicker,
	},
	mixins: [tableMixins, dateMixins, toastMessageMixins, userMixins, shoppingMixins, switchPetMixins],
	data() {
		return {
			isAPILoading: false,
			isLoadMoreLoading: false,
			selectedDateTime: null,
			desc: true,
			sortBy: "createdAt",
			statusList: [
				{
					value: "For delivery",
					name: "For Delivery",
				},
				{
					value: "For cancellation",
					name: "For Cancellation",
				},
				{
					value: "Pending Payment",
					name: "Pending Payment",
				},
				{
					value: "Out for delivery",
					name: "Out For Delivery",
				},
				{
					value: "Delivered",
					name: "Delivered",
				},
				{
					value: "Cancelled",
					name: "Cancelled",
				},
				{
					value: "Refunded",
					name: "Refunded",
				},
			],
			paymentMethods: [
				{
					value: "Store credit",
					name: "Store Credit",
				},
				{
					value: "Stripe",
					name: "Credit Card",
				},
				{
					value: "Latitude Interest Free",
					name: "Latitude Interest Free",
				},
			],
			// table
			theads: [
				{
					name: "Order Number",
					searchLabel: "f_id",
					sortLabel: "id",
					hasSearch: true,
					isDesc: false,
					style: null,
				},
				{
					name: "Ordered Date",
					searchLabel: "f_createdAt",
					sortLabel: "createdAt",
					hasDatePicker: true,
					isDesc: false,
					style: null,
				},
				{ 
					name: "Payment Method", 
					hasPaymentMethodFilter: true,
					searchLabel: "f_paymentMethod", 
					isDesc: false, 
					style: "min-width: 200px" 
				},
				{ name: "Total Price", sortLabel: "totalPrice", isDesc: false, style: null },
				{
					name: "Status",
					searchLabel: "f_status",
					sortLabel: "status",
					isDesc: false,
					style: "min-width: 200px",
					hasStatusFilter: true,
				},
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, style: "width: 170px" },
			],
			selectedOrderStatus: "",
			selectedPaymentMethod: "",
			orderList: [],
		}
	},
	created() {
		this.getTableContent()
		this.setCartCount(this.getActivePet.id)
		this.setPendingOrderCount(this.getActivePet.id)
	},
	watch: {
		selectedOrderStatus() {
			this.getTableContent(this.page, this.limit, this.sortBy, this.desc, true)
		},
		selectedPaymentMethod() {
			this.getTableContent(this.page, this.limit, this.sortBy, this.desc, true)
		},
		selectedDateTime() {
			this.getTableContent(this.page, this.limit, this.sortBy, this.desc, true)
		},
	},
	methods: {
		refreshActivePetData() {
			this.getTableContent()
			this.setCartCount(this.getActivePet.id)
			this.setPendingOrderCount(this.getActivePet.id)
		},
		getTableContent(
			page = this.page,
			limit = this.limit,
			sortBy = this.sortBy,
			desc = this.desc,
			fromFilter = false
		) {
			page = fromFilter ? 1 : this.page
			this.callTransactionHistoryAPI({ page, limit, sortBy, desc })
		},
		callTransactionHistoryAPI(queryParams) {
			this.isAPILoading = true
			queryParams["petId"] = this.getActivePet.id

			if (this.columnsFilter) {
				if (this.columnsFilter.f_id) {
					queryParams["f_id"] = this.columnsFilter.f_id
				}
			}

			if (this.selectedPaymentMethod) {
				queryParams["f_paymentMethod"] = this.selectedPaymentMethod;
			}

			if (this.selectedOrderStatus) {
				queryParams["f_status"] = this.selectedOrderStatus
			}

			if (this.selectedDateTime) {
				queryParams["f_createdAt"] = this.dateToISO(this.selectedDateTime)
			}

			TransactionService.getCustomerOrderList(queryParams)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination,
						}
					} else {
						this.showAPIErrorToast(this.toastMessages.transactions().ERROR_GET_CUSTOMER_ORDERS, res)
					}

					this.isAPILoading = false
				})
				.catch(() => {
					this.showGenericErrorToast()
					this.isAPILoading = false
				})
		},
		showOrderDetails(data) {
			this.$router.push(`/purchases/orders/${data.id}/view`)
		},
		showCart() {
			this.$router.push("/products/cart")
		},
		getClassByStatus(status) {
			const { REQUEST_CANCELLATION, CANCELLED, REFUNDED, DELIVERED, FAILED } = TRANSACTION_STATUS

			switch (status) {
				case DELIVERED:
					return "text-success"

				case REQUEST_CANCELLATION:
					return "text-warning"

				case CANCELLED:
				case REFUNDED:
				case FAILED:
					return "text-danger"

				default:
					return "text-primary"
			}
		},
		formatPaymentMethod(paymentMethod){
			if(!paymentMethod) return "";

			const paymentMethods = paymentMethod.map(method => {
				if(method.name.toLowerCase() === "stripe"){
					return "Credit Card";
				}

				return method.name;
			});

			return paymentMethods.join(" & ");
		}
	},
}
